import React, { FunctionComponent, ReactNode } from "react";
import SummaryItem from "./SummaryItem";

interface SummaryProps {
  items: Array<{ key: string; value: ReactNode; is_link?: boolean }>;
}

const Summary: FunctionComponent<SummaryProps> = ({ items }) => (
  <section className="dynamic_analysis__summary-data">
    {items.map(({ key, value, is_link }) => (
      <SummaryItem key={key} name={key} value={value} isLink={is_link} />
    ))}
  </section>
);

export default Summary;
